import type { Theme } from '@mui/material';

export const styles = {
  subline: (theme: Theme) => ({
    color: theme.colors.neutral[600],
  }),

  sublineSuffix: (theme: Theme) => ({
    color: theme.colors.neutral[600],
    fontWeight: 500,
    fontSize: 14,
  }),
};
